import { styled } from '@mui/system';
import { Pagination, Button } from '@mui/material';

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  padding: theme.spacing(4, 0, 4, 0),
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const ApplianceLinkButton = styled(Button)({
  padding: 0
});
